document.addEventListener('DOMContentLoaded', function () {
  const heroVideos = document.querySelectorAll('.hero-video-container');

  heroVideos.forEach(function (container) {
    const video = container.querySelector('video');
    const button = container.querySelector('.hero-video-sound-toggle');

    if (!video || !button) return;

    button.addEventListener('click', function () {
      video.muted = !video.muted;

      if (video.muted) {
        button.textContent = '🔇';
        button.setAttribute('aria-label', 'Turn sound on');
      } else {
        video.volume = 1;
        button.textContent = '🔊';
        button.setAttribute('aria-label', 'Turn sound off');
      }
    });
  });
});